import { createSelector } from 'reselect';

export const profileConfigSelector = createSelector(
  state => state.profileConfig,
  (state, props) => state.profile.get('currentProfileId'),
  (profileConfigState, profileId) => {
    return profileConfigState.getIn(['data', profileId]);
  }
);
